import React from "react";
import { Box, Typography, styled } from "@mui/material";

const MentorsCard: React.FC<MentorsCardProps> = ({ image, name, role }) => {
  return (
    <Card>
      <Box sx={{ width: "100%", height: "256px" }}>
        <StyledImage src={image} alt="" />
      </Box>
      <Overlay>
        <Box sx={{ display: "flex", gap: "12px", alignItems: "center" }}>
          <Typography
            variant="subtitle1"
            sx={{
              color: "#FEFEFE",
              fontWeight: 700,
              fontSize: "20px",
              lineHeight: "32px",
              fontFamily: "Space Grotesk",
              "&:hover": {
                textDecoration: "underline",
              },
            }}
          >
            {name}
          </Typography>
        </Box>
      </Overlay>
      <Typography
        sx={{
          color: "#888888",
          fontSize: 16,
          fontWeight: 400,
          lineHeight: "24px",
          marginTop: "8px",
        }}
      >
        {role}
      </Typography>
    </Card>
  );
};

export default MentorsCard;

interface MentorsCardProps {
  image?: string;
  name: string;
  role: string;
}

// Styled Components
const Card = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  position: "relative",
  [theme.breakpoints.down(300)]: {
    width: 240,
  },
}));

const StyledImage = styled("img")(({ theme }) => ({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  borderRadius: 20,
  [theme.breakpoints.down(300)]: {
    width: 268,
  },
}));

const Overlay = styled(Box)({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: 16,
  gap: 10,
});
